// centralize all fetch calls
import { ENDPOINTS } from '../utils/constants';

export async function login({ lastName, userBadgeId, role }) {
  const res = await fetch(ENDPOINTS.LOGIN, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ lastName, userBadgeId, role })
  });
  return res;
}

export async function fetchRepTeams(id) {
  const url = `/rapi${ENDPOINTS.TEAM_MEMBER_OPTIONS}/${id}/teams`;
  const res = await fetch(url);

  // Throw if status is not 2xx
  if (!res.ok) {
    let message = `Request failed with ${res.status} ${res.statusText}`;
    try {
      const body = await res.json();
      // If API sends an error message, surface it
      if (body?.error) message = body.error;
    } catch {
      // ignore parsing error, stick with default message
    }
    throw new Error(message);
  }

  return res.json();
}


export async function fetchMemberOfTeams(id) {
  try {
    const url = `/rapi${ENDPOINTS.TEAM_MEMBER_OPTIONS}/${id}/member_of_teams`;
    const res = await fetch(url);
    return res.json();
  } catch(err) {
    throw new Error('Unexpected Error', err)
  }
}

export async function fetchCompetitions() {
  const res = await fetch(`/rapi${ENDPOINTS.COMPETITIONS}`);
  return res.json();
}

export async function fetchCompetitionTeam(id) {
  const res = await fetch(`/rapi${ENDPOINTS.COMPETITION_TEAMS}/${id}`);
  return res.json();
}

export async function fetchAdminCompetitions() {
  const res = await fetch(`/rapi${ENDPOINTS.ADMIN_COMPETITIONS}`);
  return res.json();
}

export async function fetchCompetitionEvents(competitionId) {
  const res = await fetch(`/rapi${ENDPOINTS.COMPETITIONS}/${competitionId}/competition_events`);
  return res.json();
}

export async function fetchMemberOptions() {
  const res = await fetch(`/rapi${ENDPOINTS.TEAM_MEMBER_OPTIONS}`);
  const json = await res.json();
  return json.modifiedData;
}

export async function fetchCompetitionEventTeams(competition_event_id) {
  try {
    const url = `/rapi${ENDPOINTS.COMPETITION_EVENTS}/${competition_event_id}/competition_teams`;
    const res = await fetch(url);

    return res.json();
  } catch(err) {
    throw new Error('Unexpected Error', err)
  }
}

export async function createOrUpdateTeam(payload) {
  const res = await fetch(ENDPOINTS.CREATE_TEAM, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  return res.json();
}

export async function initializeTeam(payload) {
    const res = await fetch(
      `/rapi${ENDPOINTS.COMPETITION_EVENTS}/${payload.competition_event_id}/competition_teams`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }
    );
    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error('Unexpected error')
    }

    if (!res.ok) {
      const errorMessage = Array.isArray(data.errors)
        ? data.errors.join(', ')
        : 'Something went wrong';
      
      throw new Error(errorMessage);
    }

    return data
}

export async function activateTeam(team_id) {
  const res = await fetch(
      `/rapi${ENDPOINTS.COMPETITION_TEAMS}/${team_id}/activate`,
      {
        method: 'post',
        headers: { 'content-type': 'application/json' }
      }
  )
  let data;
  try {
    data = await res.json()
  } catch(err) {
    throw new Error(`unexpected error: ${err.errors}`)
  }

  if (!res.ok) {
    const errormessage = Array.isArray(data.errors)
      ? data.errors.join(', ')
      : 'something went wrong';
      
    throw new Error(errormessage);
  }

  return data
}

export async function deactivateTeam(team_id) {
  const res = await fetch(
      `/rapi${ENDPOINTS.COMPETITION_TEAMS}/${team_id}/deactivate`,
      {
        method: 'post',
        headers: { 'content-type': 'application/json' }
      }
  )
  let data;
  try {
    data = await res.json()
  } catch(err) {
    throw new Error('unexpected error')
  }

  if (!res.ok) {
    const errormessage = Array.isArray(data.errors)
      ? data.errors.join(', ')
      : 'something went wrong';
      
    throw new Error(errormessage);
  }

  return data
}

export async function createTeamMember(payload) {
    const res = await fetch(
      `/rapi${ENDPOINTS.COMPETITION_TEAMS}/${payload.competition_team_id}/competition_team_members`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }
    );
    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error('Unexpected error')
    }

    if (!res.ok) {
      const errorMessage = Array.isArray(data.errors)
        ? data.errors.join(', ')
        : 'Something went wrong';
      
      throw new Error(errorMessage);
    }

    return data
}

export async function updateCompetitionTeam(payload) {
    const res = await fetch(
      `/rapi${ENDPOINTS.COMPETITION_TEAMS}/${payload.id}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }
    );
    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error('Unexpected error')
    }

    if (!res.ok) {
      const errorMessage = Array.isArray(data.errors)
        ? data.errors.join(', ')
        : 'Something went wrong';
      
      throw new Error(errorMessage);
    }

    return data
}

export async function deleteCompetitionTeam(team_id) {
  const url = `/rapi${ENDPOINTS.COMPETITION_TEAMS}/${team_id}`;
  let res;
  let data;
  try {
    res = await fetch(url, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });

    try {
      data = await res.json(); 
    } catch {
      throw new Error('Unexpected error')
    }
    
    if (!res.ok) {
      const errorMessage = Array.isArray(data.errors)
        ? data.errors.join(', ')
        : 'Something went wrong';
     
      throw new Error(errorMessage);
    }

    return
  } catch(err) {
    throw new Error(err)
  }
}

export async function bulkDeleteCompetitionTeams(teamIds) {
  const url = `/rapi${ENDPOINTS.COMPETITION_TEAMS}/bulk_destroy`;
  try {
    await fetch(url, {
      method: 'POST', // collection action
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids: teamIds }),
    });
    return;
  } catch (err) {
    throw new Error(err);
  }
}


export async function fetchTeamMembers(competition_team_id) {
  const url = `/rapi${ENDPOINTS.COMPETITION_TEAMS}/${competition_team_id}/competition_team_members`;
  const res = await fetch(url);
  return res.json();
}

export async function deleteTeamMember(team_member_id) {
  const url = `/rapi${ENDPOINTS.COMPETITION_TEAM_MEMBERS}/${team_member_id}`;
  const res = await fetch(url, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  });
  return;
}